export const EXPLORER_PRESET_LIMITS = ['10', '50', '100', '500', '1000'] as const

/**
 * Any positive integer is a valid limit — there is no upper cap. Long-running
 * queries can always be cancelled (AbortController races the request server-side).
 */
export function normalizeExplorerLimit(value: unknown): string | null {
  const n = typeof value === 'number' ? value : Number(String(value ?? '').trim())
  if (!Number.isFinite(n) || n < 1) return null
  return String(Math.floor(n))
}

export function explorerLimitOptions(current: string): string[] {
  const normalized = normalizeExplorerLimit(current) ?? '100'
  const presets = [...EXPLORER_PRESET_LIMITS]
  if (!presets.includes(normalized as (typeof EXPLORER_PRESET_LIMITS)[number])) {
    return [...presets, normalized].sort((a, b) => Number(a) - Number(b))
  }
  return presets
}
